/**
 * Utility for detecting mobile/desktop breakpoints
 */

/**
 * Check if current viewport is mobile based on section's breakpoint
 * @param {HTMLElement} section - The section element with data-mobile-breakpoint
 * @returns {boolean} True if mobile, false if desktop
 */
export function isMobile(section) {
  const breakpoint = parseInt(section.dataset.mobileBreakpoint);
  
  // If no breakpoint specified, always treat as mobile-enabled
  if (!breakpoint) {
    return true;
  }
  
  return window.innerWidth <= breakpoint;
}

/**
 * Check if viewport is desktop (990px and above)
 * @returns {boolean}
 */
export function isDesktop() {
  return window.innerWidth >= 990;
}

/**
 * Get breakpoint value from section
 * @param {HTMLElement} section
 * @returns {number}
 */
export function getBreakpoint(section) {
  return parseInt(section.dataset.mobileBreakpoint) || 900;
}

